import _ from 'lodash'
import FileSaver from 'file-saver'
import moment from 'moment-timezone'
import URI from 'urijs'
import config from '@/config/env'

import api from '@/api/api'

import ScrollTo from '@/components/general/scroll-to/scroll-to'
import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import SelectField from '@/components/general/fields/select/select'
import SearchField from '@/components/general/fields/search/search'
import CheckboxField from '@/components/general/fields/checkbox/checkbox'
import FileField from '@/components/general/fields/file/file'
import DateField from '@/components/general/fields/date/date'

export default {
	name: 'client-record-list',
	data () {
		return {
			clients : [],
			menuOptions : [
				{
					iconClass : 'fa fa-check',
					name      : this.$t('private.clients_records.list.menu_more_options.approve'),
					action    : 'approve'
				},
				{
					iconClass : 'fa fa-times',
					name      : this.$t('private.clients_records.list.menu_more_options.disapprove'),
					action    : 'disapprove'
				}
			],
			filters : {
				cif : {
					id      : _.uniqueId('field_'),
					display : true,
					value   : '',
					name    : this.$t('private.clients_records.list.filters.cif'),
					type    : 'text',
					error   : false,
					filters : {
						type      : 'string',
						minLength : 2,
						maxLength : 100,
						required  : true
					},
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				clientCode : {
					id      : _.uniqueId('field_'),
					display : true,
					value   : '',
					name    : this.$t('private.clients_records.list.filters.client_code'),
					type    : 'text',
					error   : false,
					filters : {
						type      : 'string',
						minLength : 10,
						maxLength : 20,
						required  : true
					},
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				// email : {
				// 	id      : _.uniqueId('field_'),
				// 	display : true,
				// 	value   : '',
				// 	name    : this.$t('private.clients_records.list.filters.email'),
				// 	type    : 'email',
				// 	error   : false,
				// 	filters : {
				// 		type      : 'string',
				// 		minLength : 2,
				// 		maxLength : 100,
				// 		required  : true
				// 	}
				// },
				legalName : {
					id      : _.uniqueId('field_'),
					display : true,
					value   : '',
					name    : this.$t('private.clients_records.list.fields.legal_name'),
					type    : 'text',
					error   : false,
					filters : {
					type      : 'string',
					minLength : 2,
					maxLength : 40,
					required  : true
					},
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				state : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue :  this.$t('private.clients_records.list.filters.state_options.pendiente_ok'),
					value     : '',
					name      : this.$t('private.clients_records.list.filters.state'),
					error     : false,
					active    : false,
					options : [{
						fakeValue : this.$t('private.clients_records.list.filters.state_options.ok'),
						value : 1
					},{
						fakeValue : this.$t('private.clients_records.list.filters.state_options.no_ok'),
						value : 2
					},{
						fakeValue : this.$t('private.clients_records.list.filters.state_options.pendiente_ok'),
						value : ''
					}],
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				updated : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : '',
					value     : '',
					name      : this.$t('private.clients_records.list.filters.updated'),
					error     : false,
					active    : false,
					options : [{
						fakeValue : this.$t('private.clients_records.list.filters.updated_options.yes'),
						value : true
					}, {
						fakeValue: this.$t('private.clients_records.list.filters.updated_options.not'),
						value: false
					}],
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				ascending : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : '',
					value     : '',
					name      : this.$t('private.clients_records.list.filters.sort_ascending'),
					error     : false,
					active    : false,
					options : [{
						fakeValue : this.$t('private.clients_records.list.filters.sort_options.created_at'),
						value : 'createdAt'
					},{
						fakeValue : this.$t('private.clients_records.list.filters.sort_options.cif'),
						value : 'cif'
					},{
						fakeValue : this.$t('private.clients_records.list.filters.sort_options.client_code'),
						value : 'clientCode'
					}],
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				descending : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : this.$t('private.clients_records.list.filters.sort_options.created_at'),
					value     : 'createdAt',
					name      : this.$t('private.clients_records.list.filters.sort_descending'),
					error     : false,
					active    : false,
					options : [{
						fakeValue : this.$t('private.clients_records.list.filters.sort_options.created_at'),
						value : 'createdAt'
					},{
						fakeValue : this.$t('private.clients_records.list.filters.sort_options.cif'),
						value : 'cif'
					},{
						fakeValue : this.$t('private.clients_records.list.filters.sort_options.client_code'),
						value : 'clientCode'
					}],
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				limit : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : this.$t('private.clients_records.list.filters.limit_options.10'),
					value     : 10,
					name      : this.$t('private.clients_records.list.filters.limit'),
					error     : false,
					active    : false,
					options : [{
						fakeValue : this.$t('private.clients_records.list.filters.limit_options.10'),
						value : 10
					},{
						fakeValue : this.$t('private.clients_records.list.filters.limit_options.25'),
						value : 25
					},{
						fakeValue : this.$t('private.clients_records.list.filters.limit_options.50'),
						value : 50
					},{
						fakeValue : this.$t('private.clients_records.list.filters.limit_options.100'),
						value : 100
					}],
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				skip : {
					value : 0
				}
			},
			getClientsRecordsActive : false,
			activateFilters : false,
			haveData : false,
			nextPage : false,
			disapproveClientsRecords : {
				fields : {
					id : {
						value   : '',
						filters : {
							type     : 'string',
							required : true
						}
					}
				},
				active : false
			},
			exportClientsRecordsActive : false,
			approveClientsRecordsWindow : {
				display : false,
				clientRecord : {},
				formApprove : {
					fields : {
						clientCode : {
							id      : _.uniqueId('field_'),
							display : true,
							value   : '',
							name    : this.$t('private.clients_records.list.fields.client_code'),
							type    : 'text',
							error   : false,
							filters : {
								type      : 'string',
								minLength : 8,
								maxLength : 8,
								required  : true
							}
						}
					},
					active : false
				}
			},
			formCreate : {
				fields : {
					seller : {
						id        : _.uniqueId('field_'),
						display   : true,
						fakeValue : '',
						value     : '',
						name      : this.$t('private.clients_records.list.fields.seller'),
						error     : false,
						active    : false,
						options : [],
						filters : {
							type      : 'string',
							required  : true
						}
					},
					cfia : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.cfia'),
						type    : 'text',
						error   : false,
						filters : {
							type      : 'string'
						}
					},
					cif : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.cif'),
						type    : 'text',
						error   : false,
						filters : {
							type      : 'string',
							minLength : 2,
							maxLength : 15,
							required  : true
						}
					},
					clientCode : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.client_code'),
						type    : 'text',
						error   : false,
						filters : {
							type      : 'string',
							minLength : 8,
							maxLength : 8,
							required  : true
						}
					},
					email : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.email'),
						type    : 'email',
						error   : false,
						filters : {
							type      : 'email',
							minLength : 7,
							maxLength : 100,
							required  : true
						}
					},
					employeesQuantity : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.employees_quantity'),
						type    : 'number',
						error   : false,
						filters : {
							type      : 'number',
							required  : true
						}
					},
					loungesQuantity : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.lounges_quantity'),
						type    : 'number',
						error   : false,
						filters : {
							type      : 'number',
							required  : true
						}
					},
					legalName : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.legal_name'),
						type    : 'text',
						error   : false,
						filters : {
							type      : 'string',
							minLength : 2,
							maxLength : 40,
							required  : true
						}
					},
					// dischargeDate : {
					// 	id        : _.uniqueId('field_'),
					// 	display   : true,
					// 	fakeValue : '',
					// 	value     : '',
					// 	name      : this.$t('private.clients_records.list.fields.discharge_date'),
					// 	error     : false,
					// 	active    : false,
					// 	filters   : {
					// 		type      : 'date',
					// 		required  : true
					// 	}
					// },
					// status : {
					// 	id        : _.uniqueId('field_'),
					// 	display   : true,
					// 	fakeValue : this.$t('private.clients_records.list.fields.status_options.active'),
					// 	value     : true,
					// 	name      : this.$t('private.clients_records.list.fields.status'),
					// 	error     : false,
					// 	active    : false,
					// 	options : [{
					// 		fakeValue : this.$t('private.clients_records.list.fields.status_options.active'),
					// 		value : true
					// 	},{
					// 		fakeValue : this.$t('private.clients_records.list.fields.status_options.inactive'),
					// 		value : false
					// 	}],
					// 	filters : {
					// 		type      : 'boolean',
					// 		required  : true
					// 	}
					// },
					// recruitingLR : {
					// 	id        : _.uniqueId('field_'),
					// 	display   : true,
					// 	fakeValue : '',
					// 	value     : '',
					// 	name      : this.$t('private.clients_records.list.fields.recruiting_lr'),
					// 	error     : false,
					// 	active    : false,
					// 	options : [{
					// 		fakeValue : this.$t('private.clients_records.list.fields.recruiting_lr_options.yes'),
					// 		value : true
					// 	},{
					// 		fakeValue : this.$t('private.clients_records.list.fields.recruiting_lr_options.no'),
					// 		value : false
					// 	}],
					// 	filters : {
					// 		type      : 'boolean',
					// 		required  : true
					// 	}
					// },
					mktNews : {
						id        : _.uniqueId('field_'),
						display   : true,
						fakeValue : '',
						value     : '',
						name      : this.$t('private.clients_records.list.fields.mkt_news'),
						error     : false,
						active    : false,
						options : [{
							fakeValue : this.$t('private.clients_records.list.fields.mkt_news_options.yes'),
							value : true
						},{
							fakeValue : this.$t('private.clients_records.list.fields.mkt_news_options.no'),
							value : false
						}],
						filters : {
							type      : 'boolean',
							required  : true
						}
					},
					// conditions : {
					// 	id        : _.uniqueId('field_'),
					// 	display   : true,
					// 	name      : this.$t('private.clients_records.list.fields.conditions'),
					// 	error     : false,
					// 	value     : {
					// 		imageConditions : false
					// 	},
					// 	options   : {
					// 		imageConditions : {
					// 			name : this.$t('private.clients_records.list.fields.conditions_options.image_conditions')
					// 		}
					// 	},
					// 	filters   : {
					// 		type : 'manyOptions',
					// 		enum : ['imageConditions']
					// 	}
					// }
				},
				active : false
			},
			displayCreateClient : false,
			formUpdate : {
				fields : {
					id : {
						value   : '',
						filters : {
							type     : 'string',
							required : true
						}
					},
					seller : {
						id        : _.uniqueId('field_'),
						display   : true,
						fakeValue : '',
						value     : '',
						name      : this.$t('private.clients_records.list.fields.seller'),
						error     : false,
						active    : false,
						options : [],
						filters : {
							type      : 'string',
							required  : true
						}
					},
					cfia : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.cfia'),
						type    : 'text',
						error   : false,
						filters : {
							type      : 'string'
						}
					},
					cif : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.cif'),
						type    : 'text',
						error   : false,
						filters : {
							type      : 'string',
							minLength : 2,
							maxLength : 15,
							required  : true
						}
					},
					clientCode : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.client_code'),
						type    : 'text',
						error   : false,
						filters : {
							type      : 'string',
							minLength : 8,
							maxLength : 8,
							required  : true
						}
					},
					email : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.email'),
						type    : 'email',
						error   : false,
						filters : {
							type      : 'email',
							minLength : 7,
							maxLength : 100,
							// required  : true
						}
					},
					employeesQuantity : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.employees_quantity'),
						type    : 'number',
						error   : false,
						filters : {
							type      : 'number',
							// required  : true
						}
					},
					loungesQuantity : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.lounges_quantity'),
						type    : 'number',
						error   : false,
						filters : {
							type      : 'number',
							// required  : true
						}
					},
					legalName : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('private.clients_records.list.fields.legal_name'),
						type    : 'text',
						error   : false,
						filters : {
							type      : 'string',
							minLength : 2,
							maxLength : 40,
							required  : true
						}
					},
					dischargeDate : {
						id        : _.uniqueId('field_'),
						display   : true,
						fakeValue : '',
						value     : '',
						name      : this.$t('private.clients_records.list.fields.discharge_date'),
						error     : false,
						active    : false,
						filters   : {
							type      : 'date',
							required  : true
						}
					},
					status : {
						id        : _.uniqueId('field_'),
						display   : true,
						fakeValue : '',
						value     : '',
						name      : this.$t('private.clients_records.list.fields.status'),
						error     : false,
						active    : false,
						options : [{
							fakeValue : this.$t('private.clients_records.list.fields.status_options.active'),
							value : true
						},{
							fakeValue : this.$t('private.clients_records.list.fields.status_options.inactive'),
							value : false
						}],
						filters : {
							type      : 'boolean',
							required  : true
						}
					},
					recruitingLR : {
						id        : _.uniqueId('field_'),
						display   : true,
						fakeValue : '',
						value     : '',
						name      : this.$t('private.clients_records.list.fields.recruiting_lr'),
						error     : false,
						active    : false,
						options : [{
							fakeValue : this.$t('private.clients_records.list.fields.recruiting_lr_options.yes'),
							value : true
						},{
							fakeValue : this.$t('private.clients_records.list.fields.recruiting_lr_options.no'),
							value : false
						}],
						filters : {
							type      : 'boolean',
							required  : true
						}
					},
					mktNews : {
						id        : _.uniqueId('field_'),
						display   : true,
						fakeValue : '',
						value     : '',
						name      : this.$t('private.clients_records.list.fields.mkt_news'),
						error     : false,
						active    : false,
						options : [{
							fakeValue : this.$t('private.clients_records.list.fields.mkt_news_options.yes'),
							value : true
						},{
							fakeValue : this.$t('private.clients_records.list.fields.mkt_news_options.no'),
							value : false
						}],
						filters : {
							type      : 'boolean',
							required  : true
						}
					},
					conditions : {
						id        : _.uniqueId('field_'),
						display   : true,
						name      : this.$t('private.clients_records.list.fields.conditions'),
						error     : false,
						value     : {
							imageConditions : false
						},
						options   : {
							imageConditions : {
								name : this.$t('private.clients_records.list.fields.conditions_options.image_conditions')
							}
						},
						filters   : {
							type : 'manyOptions',
							enum : ['imageConditions']
						}
					}
				},
				active : false
			},
			displayUpdateClient : false,
			displayFoo : false
		}
	},
	methods : {
		rowClicked (element, value) {

			element.rowSelected = value

			this.displayFoo ? this.displayFoo = false : this.displayFoo = true

		},
		getClientsRecords () {

			let vm = this

			vm.clientsRecords = []
			vm.getClientsRecordsActive = true

			let dataToSend = {
				cif          : vm.filters.cif.value        ? vm.filters.cif.value        : '',
				clientCode   : vm.filters.clientCode.value ? vm.filters.clientCode.value : '',
				legalName    : vm.filters.legalName.value  ? vm.filters.legalName.value  : '',
				state        : vm.filters.state.value      ? vm.filters.state.value      : '',
				updateClient : vm.filters.updated.value    ? vm.filters.updated.value    : '',
				ascending    : vm.filters.ascending.value  ? vm.filters.ascending.value  : '',
				descending   : vm.filters.descending.value ? vm.filters.descending.value : '',
				limit        : vm.filters.limit.value + 1,
				skip         : vm.filters.skip.value
			}

			api
				.clientsRecords
				.getClientsRecords(dataToSend)
				.then( (response) => {

					vm.getClientsRecordsActive = false

					if( response.status != 200 ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					if( !response.data.success ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					vm.clientsRecords = response.data.clientsRecords

					if( vm.clientsRecords.length > 0 && !vm.haveData ){

						vm.haveData = true

					}

					if( vm.clientsRecords.length > vm.filters.limit.value ){

						vm.nextPage = true

						vm.clientsRecords.pop()

					}else{

						vm.nextPage = false

					}

						_.each(vm.clientsRecords, function (x) {

							if(x.pdf) {

								var uri_org  = new URI(x.pdf.url),
									pathname   = uri_org.pathname();

								x.pdf.url = config.api.baseUrl + pathname;

							}

						})



				})

		},
		goToBackPage () {

			let vm = this

			if( vm.filters.skip.value != 0 ){

				vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

				vm.getClientsRecords()

			}

		},
		goToNextPage () {

			let vm = this

			if( vm.nextPage ){

				vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

				vm.getClientsRecords()

			}

		},
		optionSelected (data) {

			let vm = this

			if( data.action == 'approve' ){

				vm.approveClientsRecordsWindow.clientRecord = data.element
				vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value = ''

				vm.approveClientsRecordsWindow.display = true

			}else if( data.action == 'disapprove' ){

				vm.disapproveSubmit(data.element)

			}

		},
		formApproveSubmit () {

			let vm = this

			if( vm.approveClientsRecordsWindow.formApprove.active ){

				return

			}

			vm.approveClientsRecordsWindow.formApprove.active = true

			vm.$root.$emit('validate', [vm.approveClientsRecordsWindow.formApprove.fields, (response) => {

				if( !response.success ){

					vm.approveClientsRecordsWindow.formApprove.active = false

					response.type = 'error'

					response.field.error = true

					let dataToScroll = {
						selector : '#' + response.field.id,
						target   : 'html, body'
					}

					ScrollTo.submit(dataToScroll)

					vm.$root.$emit('showMessage', response)

					return

				}

				// let dataToSend = {
				// 	clientRecordId : vm.approveClientsRecordsWindow.clientRecord.objectId,
				// 	clientCode     : vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value
				// }

				let dataToSend = `?clientCode=${vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value}`
				api
					.clients
					.getClients(dataToSend)
					.then( (response) => {

						if( response.status != 200 ){

							let message = {
								message : [vm.$t('errors.custom.001')],
								type    : 'error'
							}

							vm.$root.$emit('showMessage', message)

							return

						}

						if( !response.data.success ){

							vm.approveClientsRecordsWindow.formApprove.active = false

							// if( response.data.error.code == '016' ){
							//
							// 	vm.formUpdate.fields.clientCode.error = true
							//
							// 	let message = {
							// 		message : [vm.$t('errors.custom.016')],
							// 		type    : 'error'
							// 	}
							//
							// 	vm.$root.$emit('showMessage', message)
							//
							// 	return
							//
							// }

							let message = {
								message : [vm.$t('errors.custom.001')],
								type    : 'error'
							}

							vm.$root.$emit('showMessage', message)

							return

						}

						if( response.data.client ){

							let client = response.data.client

							vm.formUpdate.fields.id.value                         = client.id ? client.id : ''
							vm.formUpdate.fields.seller.fakeValue                 = client.seller ? client.seller.fullname + ' ( ' + client.seller.username + ' )' : ''
							vm.formUpdate.fields.seller.value                     = client.seller ? client.seller.objectId : ''
							vm.formUpdate.fields.cfia.value                       = client.cfia ? client.cfia : ''
							vm.formUpdate.fields.cif.value                        = client.cif ? client.cif : ''
							vm.formUpdate.fields.clientCode.value                 = client.clientCode ? client.clientCode : ''
							vm.formUpdate.fields.email.value                      = client.email ? client.email : ''
							vm.formUpdate.fields.employeesQuantity.value          = client.employeesQuantity ? client.employeesQuantity : 0
							vm.formUpdate.fields.loungesQuantity.value            = client.loungesQuantity ? client.loungesQuantity : 0
							vm.formUpdate.fields.legalName.value                  = client.legalName ? client.legalName : ''
							vm.formUpdate.fields.dischargeDate.fakeValue          = client.dischargeDate ? moment(client.dischargeDate.iso).format('DD-MM-YYYY') : ''
							vm.formUpdate.fields.dischargeDate.value              = client.dischargeDate ? client.dischargeDate.iso : ''
							vm.formUpdate.fields.status.fakeValue                 = client.status          ? vm.$t('private.clients_records.list.fields.status_options.active') : vm.$t('private.clients_records.list.fields.status_options.inactive')
							vm.formUpdate.fields.status.value                     = client.status          ? true : false
							vm.formUpdate.fields.recruitingLR.fakeValue           = client.recruitingLR    ? vm.$t('private.clients_records.list.fields.recruiting_lr_options.yes') : vm.$t('private.clients_records.list.fields.recruiting_lr_options.no')
							vm.formUpdate.fields.recruitingLR.value               = client.recruitingLR    ? true : false
							vm.formUpdate.fields.mktNews.fakeValue                = client.mktNews         ? vm.$t('private.clients_records.list.fields.mkt_news_options.yes') : vm.$t('private.clients_records.list.fields.mkt_news_options.no')
							vm.formUpdate.fields.mktNews.value                    = client.mktNews         ? true : false
							vm.formUpdate.fields.conditions.value.imageConditions = client.imageConditions ? true : false

							vm.displayUpdateClient = true

						}else{

							vm.formCreate.fields.cfia.value              = vm.approveClientsRecordsWindow.clientRecord.cfia
							vm.formCreate.fields.cif.value               = vm.approveClientsRecordsWindow.clientRecord.nif
							vm.formCreate.fields.clientCode.value        = vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value
							vm.formCreate.fields.email.value             = vm.approveClientsRecordsWindow.clientRecord.email
							vm.formCreate.fields.employeesQuantity.value = vm.approveClientsRecordsWindow.clientRecord.employeesQuantity
							vm.formCreate.fields.loungesQuantity.value   = vm.approveClientsRecordsWindow.clientRecord.loungesQuantity
							vm.formCreate.fields.legalName.value         = vm.approveClientsRecordsWindow.clientRecord.legalName
							vm.formCreate.fields.mktNews.fakeValue       = vm.approveClientsRecordsWindow.clientRecord.mktNews ? vm.$t('private.clients_records.list.fields.mkt_news_options.yes') : vm.$t('private.clients_records.list.fields.mkt_news_options.no')
							vm.formCreate.fields.mktNews.value           = vm.approveClientsRecordsWindow.clientRecord.mktNews ? true : false

							vm.displayCreateClient = true

						}

						vm.approveClientsRecordsWindow.formApprove.active = false

					})

			}])

		},
		searchSellers (data) {

			let vm = this

			vm.getSellersActive = true

			let dataToSend = '?descending=createdAt&fullname=' + data

			api
				.sellers
				.getSellers(dataToSend)
				.then( (response) => {

					vm.getSellersActive = false

					if( response.status != 200 ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					if( !response.data.success ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					let sellers = _.sortBy(response.data.sellers, 'username')

					sellers = _.map(sellers, (seller) => {

						return {
							fakeValue : seller.fullname + ' ( ' + seller.username + ' )',
							value : seller.id
						}

					})

					vm.formCreate.fields.seller.options = sellers
					vm.formUpdate.fields.seller.options = sellers

				})

		},
		sellerSelected (data) {

			let vm = this

			vm.formCreate.fields.seller.value = data
			vm.formUpdate.fields.seller.value = data

		},
		formUpdateSubmit () {

			let vm = this

			if( vm.formUpdate.active ){

				return

			}

			vm.formUpdate.active = true

			vm.$root.$emit('validate', [vm.formUpdate.fields, (response) => {

				if( !response.success ){

					vm.formUpdate.active = false

					response.type = 'error'

					response.field.error = true

					let dataToScroll = {
						selector : '#' + response.field.id,
						target   : 'html, body'
					}

					ScrollTo.submit(dataToScroll)

					vm.$root.$emit('showMessage', response)

					return

				}

				let dataToSend = {
					id                : vm.formUpdate.fields.id.value,
					seller            : vm.formUpdate.fields.seller.value,
					cfia              : vm.formUpdate.fields.cfia.value,
					cif               : vm.formUpdate.fields.cif.value,
					clientCode        : vm.formUpdate.fields.clientCode.value,
					email             : vm.formUpdate.fields.email.value,
					employeesQuantity : vm.formUpdate.fields.employeesQuantity.value,
					loungesQuantity   : vm.formUpdate.fields.loungesQuantity.value,
					legalName         : vm.formUpdate.fields.legalName.value,
					dischargeDate     : moment(vm.formUpdate.fields.dischargeDate.value).endOf('day').toDate(),
					status            : vm.formUpdate.fields.status.value,
					recruitingLR      : vm.formUpdate.fields.recruitingLR.value,
					mktNews           : vm.formUpdate.fields.mktNews.value,
					imageConditions   : vm.formUpdate.fields.conditions.value.imageConditions
				}

				api
					.clients
					.updateClient(dataToSend)
					.then( (response) => {

						if( response.status != 200 ){

							let message = {
								message : [vm.$t('errors.custom.001')],
								type    : 'error'
							}

							vm.$root.$emit('showMessage', message)

							return

						}

						if( !response.data.success ){

							if( response.data.error.code == '002' ){

								vm.formUpdate.fields.clientCode.error = true

								let message = {
									message : [vm.$t('errors.custom.002')],
									type    : 'error'
								}

								vm.$root.$emit('showMessage', message)

							}

							if( response.data.error.code == '007' ){

								vm.formUpdate.fields.cif.error = true

								let message = {
									message : [vm.$t('errors.custom.007')],
									type    : 'error'
								}

								vm.$root.$emit('showMessage', message)

							}

							return

						}

						let dataToSend = {
							clientRecordId : vm.approveClientsRecordsWindow.clientRecord.objectId,
							clientCode : vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value
						}

						api
							.clientsRecords
							.approveClientsRecords(dataToSend)
							.then( (response) => {

								vm.formUpdate.active = false

								vm.approveClientsRecordsWindow.formApprove.active = false

								if( response.status != 200 ){

									let message = {
										message : [vm.$t('errors.custom.001')],
										type    : 'error'
									}

									vm.$root.$emit('showMessage', message)

									return

								}

								if( !response.data.success ){

									if( response.data.error.code == '002' ){

										vm.approveClientsRecordsWindow.formApprove.fields.clientCode.error = true

										let message = {
											message : [vm.$t('errors.custom.002')],
											type    : 'error'
										}

										vm.$root.$emit('showMessage', message)

									}

									return

								}

								let message = {
									message : [vm.$t('private.clients_records.list.approve_client_record_success')],
									type    : 'success'
								}

								vm.$root.$emit('showMessage', message)

								vm.getClientsRecords()

								vm.approveClientsRecordsWindow.display = false

								vm.approveClientsRecordsWindow.clientRecord                        = {}
								vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value = ''

								vm.displayUpdateClient = false

								vm.formUpdate.fields.id.value                         = ''
								vm.formUpdate.fields.seller.value                     = ''
								vm.formUpdate.fields.cfia.value                       = ''
								vm.formUpdate.fields.cif.value                        = ''
								vm.formUpdate.fields.clientCode.value                 = ''
								vm.formUpdate.fields.email.value                      = ''
								vm.formUpdate.fields.employeesQuantity.value          = ''
								vm.formUpdate.fields.loungesQuantity.value            = ''
								vm.formUpdate.fields.legalName.value                  = ''
								vm.formUpdate.fields.dischargeDate.value              = ''
								vm.formUpdate.fields.status.value                     = ''
								vm.formUpdate.fields.recruitingLR.value               = ''
								vm.formUpdate.fields.mktNews.value                    = ''
								vm.formUpdate.fields.conditions.value.imageConditions = false

							})

					});

			}])

		},
		formCreateSubmit () {

			let vm = this

			if( vm.formCreate.active ){

				return

			}

			vm.formCreate.active = true

			vm.$root.$emit('validate', [vm.formCreate.fields, (response) => {

				if( !response.success ){

					vm.formCreate.active = false

					response.type = 'error'

					response.field.error = true

					let dataToScroll = {
						selector : '#' + response.field.id,
						target   : 'html, body'
					}

					ScrollTo.submit(dataToScroll)

					vm.$root.$emit('showMessage', response)

					return

				}

				let dataToSend = {
					seller                : vm.formCreate.fields.seller.value,
					cfia                  : vm.formCreate.fields.cfia.value,
					cif                   : vm.formCreate.fields.cif.value,
					clientCode            : vm.formCreate.fields.clientCode.value,
					legalName             : vm.formCreate.fields.legalName.value,
					dischargeDate         : moment().toDate(),
					email                 : vm.formCreate.fields.email.value,
					employeesQuantity     : vm.formCreate.fields.employeesQuantity.value,
					loungesQuantity       : vm.formCreate.fields.loungesQuantity.value,
					// dischargeDate     : moment(vm.formCreate.fields.dischargeDate.value).endOf('').toDate(),
					// status            : vm.formCreate.fields.status.value,
					// recruitingLR      : vm.formCreate.fields.recruitingLR.value,
					mktNews           : vm.formCreate.fields.mktNews.value,
					// imageConditions   : vm.formCreate.fields.conditions.value.imageConditions
				}

				api
					.clients
					.createClient(dataToSend)
					.then( (response) => {

						if( response.status != 200 ){

							let message = {
								message : [vm.$t('errors.custom.001')],
								type    : 'error'
							}

							vm.$root.$emit('showMessage', message)

							return

						}

						if( !response.data.success ){

							if( response.data.error.code == '002' ){

								vm.formCreate.fields.clientCode.error = true

								let message = {
									message : [vm.$t('errors.custom.002')],
									type    : 'error'
								}

								vm.$root.$emit('showMessage', message)

							}

							if( response.data.error.code == '007' ){

								vm.formCreate.fields.cif.error = true

								let message = {
								  message : [vm.$t('errors.custom.007')],
								  type    : 'error'
								}

								vm.$root.$emit('showMessage', message)

							}

							return

						}

						let dataToSend = {
							clientRecordId : vm.approveClientsRecordsWindow.clientRecord.objectId,
							clientCode : vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value
						}

						api
							.clientsRecords
							.approveClientsRecords(dataToSend)
							.then( (response) => {

								vm.formCreate.active = false

								vm.approveClientsRecordsWindow.formApprove.active = false

								if( response.status != 200 ){

									let message = {
										message : [vm.$t('errors.custom.001')],
										type    : 'error'
									}

									vm.$root.$emit('showMessage', message)

									return

								}

								if( !response.data.success ){

									if( response.data.error.code == '002' ){

										vm.approveClientsRecordsWindow.formApprove.fields.clientCode.error = true

										let message = {
											message : [vm.$t('errors.custom.002')],
											type    : 'error'
										}

										vm.$root.$emit('showMessage', message)

									}

									return

								}

								let message = {
									message : [vm.$t('private.clients_records.list.approve_client_record_success')],
									type    : 'success'
								}

								vm.$root.$emit('showMessage', message)

								vm.getClientsRecords()

								vm.approveClientsRecordsWindow.display = false

								vm.approveClientsRecordsWindow.clientRecord                        = {}
								vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value = ''

								vm.displayCreateClient = false

								vm.formCreate.fields.seller.value                     = ''
								vm.formCreate.fields.cif.value                        = ''
								vm.formCreate.fields.clientCode.value                 = ''
								vm.formCreate.fields.legalName.value                  = ''
								// vm.formCreate.fields.dischargeDate.value              = ''
								// vm.formCreate.fields.email.value                      = ''
								// vm.formCreate.fields.employeesQuantity.value          = ''
								// vm.formCreate.fields.loungesQuantity.value            = ''
								// vm.formCreate.fields.dischargeDate.value              = ''
								// vm.formCreate.fields.status.value                     = ''
								// vm.formCreate.fields.recruitingLR.value               = ''
								vm.formCreate.fields.mktNews.value                    = ''
								// vm.formCreate.fields.conditions.value.imageConditions = false

							})

					});

			}])

		},
		disapproveSubmit (element) {

			let vm = this

			let questionModal = {
				title : this.$t('private.clients_records.list.question_modal.title'),
				question : this.$t('private.clients_records.list.question_modal.question')
			}

			vm.$root.$emit('question-modal', [questionModal, (response) => {

				if(response){

					let dataToSend = {
						id : element.objectId
					}

					api
						.clientsRecords
						.disapproveClientsRecords(dataToSend)
						.then( (response) => {

							if( response.status != 200 ){

								let message = {
									message : [vm.$t('errors.custom.001')],
									type    : 'error'
								}

								vm.$root.$emit('showMessage', message)

								return

							}

							if( !response.data.success ){

								if( response.data.error.code == 101 ){

									let message = {
										message : [vm.$t('errors.parse.101')],
										type    : 'error'
									}

									vm.$root.$emit('showMessage', message)

								}

								return

							}

							let message = {
								message : [vm.$t('private.clients_records.list.disapprove_success')],
								type    : 'success'
							}

							vm.$root.$emit('showMessage', message)

							vm.getClientsRecords()

						});

				}

			}])

		},
		exportClientsRecords () {

			let vm = this

			let dataToSend = {
				timeZone: moment.tz.guess()
			}

			if( vm.exportClientsRecordsActive ){

				let message = {
					message : [vm.$t('private.clients_records.list.please_wait')],
					type    : 'error'
				}

				vm.$root.$emit('showMessage', message)

				return

			}

			vm.exportClientsRecordsActive = true

			api
				.clientsRecords
				.exportClientsRecords(dataToSend)
				.then( (response) => {

					vm.exportClientsRecordsActive = false

					if( response.status != 200 ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					let file    = new Blob([response.data], { type : 'application/vnd.ms-excel' })
					let fileURL = URL.createObjectURL(file)

					FileSaver.saveAs(file, 'clients_records.xlsx')

				})

		},
		parseDate (date) {

			return moment(date).format('DD-MM-YYYY')

		}
	},
	components : {
		MenuMoreOptions,
		TextField,
		SelectField,
		SearchField,
		CheckboxField,
		FileField,
		DateField
	},
	created () {

		let vm = this

		vm.getClientsRecords()

		vm.searchSellers('')

	}
}



// WEBPACK FOOTER //
// ./src/components/private/clients-records/list/script.js